<template>
  <card class="card-user">
    <div class="author">
      <div>
        <div class="avatar">
          <avatar
            :username="user.full_name"
            background-color="#aaa"
            :size="120"
            color="white" />
        </div>
        <h4 class="title mb-1 user-full-name">
          {{ user.full_name }} <span class="username">({{ user.username }})</span>
        </h4>
        <p class="user-email">{{ user.email }}</p>
        <p class="user-role">{{ user.role }}</p>
      </div>
      <div class="row justify-content-center">
        <div class="col-xl-10">
          <div class="card-description">
            <p class="d-flex justify-content-between">
              <strong class="mr-1 bold">Last updated</strong>
              <span class="updated-at">{{ formatDate(user.updated_at) }}</span>
            </p>
            <p class="d-flex justify-content-between">
              <strong class="mr-1 bold">Updated by</strong>
              <span class="updated-by">{{ updatedBy }}</span>
            </p>
            <p class="d-flex justify-content-between">
              <strong class="mr-1 bold">User since</strong>
              <span class="created-at">{{ formatDate(user.created_at) }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </card>
</template>
<script>
import Avatar from 'vue-avatar';
import moment from 'moment-timezone';

export default {
  name: 'UserProfileCard',
  components: {
    Avatar,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    updatedBy() {
      if (this.user.updated_by) return this.user.updated_by.full_name;
      return '--';
    },
  },
  methods: {
    formatDate(date) {
      if (date) {
        return moment(date).calendar();
      }
      return '--';
    },
  },
};
</script>
<style>
.bold {
  font-weight: bold;
}
.card-user .avatar {
  border: none;
}
</style>
